class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('button[type="button"]');

    // Prevent crashing if structure is incomplete
    if (!this.detailsContainer || !this.summaryToggle) {
      console.warn('DetailsModal: Missing <details> or <summary> inside <details-modal>');
      return;
    }

    // Handle ESC key to close
    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close();
      }
    });

    // Toggle on summary click
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.setAttribute('role', 'button');

    // Close button (optional)
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const container = event.target.closest('details');
    container.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const container = event.target.closest('details');

    container.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const trapElement = this.detailsContainer.querySelector('[tabindex="-1"]');
    const inputElement = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (typeof trapFocus === 'function') {
      trapFocus(trapElement, inputElement);
    }
  }

  close(focusToggle = true) {
    if (!this.detailsContainer) return;
    
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    }

    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

// Register the custom element
customElements.define('details-modal', DetailsModal);
